<template>
  <div class="my-account">

    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      class="page_scroll">
      <van-nav-bar
        title="账号管理"
        left-arrow
        @click-left="onClickLeft"
      />
      <ul class="my-account-list">
        <li class="items clearfix">
          <!-- @click="updateAvator" -->
          <a class="avator">
            <span class="items-left">头像设置</span>
            <div class="items-right right-avator">
              <img v-lazy="accountInfo.photo" alt="">
              <span class="items-next"></span>
              <!-- /api/api/uploadImg -->
              <cube-upload
                ref="upload"
                v-model="files"
                :action="'/api/uploadImg'"
                @files-added="filesAdded"
                @file-success="filesSuccess"
                @file-error="fileError">
                <div class="clear-fix">
                  <cube-upload-file v-for="(file, i) in files" :file="file" :key="i"></cube-upload-file>
                  <cube-upload-btn :multiple="false">
                    <div>
                      <i></i>
                      <p></p>
                    </div>
                  </cube-upload-btn>
                </div>
              </cube-upload>
            </div>
          </a>
        </li>
        <li class="items clearfix">
          <a class="set-nick">
            <span class="items-left">昵称</span>
            <div class="items-right" @click="isShowPop">
              <span class="items-right-text">{{accountInfo.name}}</span>
              <span class="items-next"></span>
            </div>
          </a>
        </li>
        <li class="items sex clearfix">
          <a class="set-sex">
            <span class="items-left">性别</span>
            <div class="items-right" @click="setSex">
              <span class="items-right-text">{{accountInfo.sex}}</span>
              <span class="items-next"></span>
            </div>
          </a>
        </li>
        <li class="items clearfix">
          <router-link :to="{name:'resetPhone',params: {info:'1'}}">
            <a class="update-phone">
              <span class="items-left">修改手机号</span>
              <div class="items-right">
                <span class="items-next"></span>
              </div>
            </a>
          </router-link>
        </li>

      </ul>
    </cube-scroll>
    <div class="login-out-account">
      <a href="javascript:;" @click="loginOut">退出当前账号</a>
    </div>
    <!-- 点击设置地址 -->
    <!-- v-show="" -->
    <div class="m-pop y-pop2 addressPop" v-show="isPop">
      <div class="pop-bg"></div>
      <div class="inner2" v-show="setNickShow">
        <div class="nick-input">
          <!-- <label for=""> 收件人：</label> -->
          <input type="text" v-model="nickName" placeholder="请输入昵称"/>
        </div>
        <div class="btn-area">
          <a style="background-color:#333;border:1px solid #333;color:#fff;"
             @click.prevent="setNickCancel">取消</a>
          <a style="background-color:#F6F6F6;border:1px solid rgba(51, 51, 51, 0.2);color:#666;"
             @click.prevent="setNickSure">确定</a>
        </div>
      </div>
      <div class="inner2" v-show="sexShow">
        <div class="sex-input-box">
          <!--
                    <div class="sexName">
                      <span>{{setValue}}</span>
                      <span class="sex-input" :class="checked ? 'checked': ''" @click="selectGood()"></span>
                    </div>
                    <div class="sexName">
                      <span>{{setValue2}}</span>
                      <span class="sex-input" :class="checked ? '': 'checked'" @click="selectGood()"></span>
                    </div>
                    -->

          <el-radio-group v-model="radiogroup" size="small">
            <el-radio label="男" border></el-radio>
            <el-radio label="女" border></el-radio>
          </el-radio-group>

        </div>
        <div class="btn-area">
          <a style="background-color:#333;border:1px solid #333;color:#fff;"
             @click.prevent="sexCancel">取消</a>
          <a style="background-color:#F6F6F6;border:1px solid rgba(51, 51, 51, 0.2);color:#666;"
             @click.prevent="sexNickSure">确定</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   import Vue from 'vue'
   import {NavBar} from 'vant'

   Vue.use(NavBar)
   export default {
      name: 'account',
      data() {
         return {
            items: [],
            options: {},
            user_id: localStorage.getItem('user_id'),
            // name: localStorage.getItem('name'),
            // photo: localStorage.getItem('photo'),
            // sex: localStorage.getItem('sex'),
            setNickShow: false,
            nickName: '',
            isPop: false,
            sexShow: false,
            setValue: '男',
            setValue2: '女',
            checked: true,

            accountInfo: {},
            isOver: true,
            files: [],

            radiogroup: '',
         }
      },
      created() {
         this.loadPage()
         this.$loading.show()
         // this.$share.WxInit()
      },
      methods: {
         // 返回
         onClickLeft() {
            this.$router.go(-1)
         },
         loadPage() {
            this.$http.api.accountInit({
               user_id: this.user_id
            }).then(result => {
               this.$loading.hide()
               this.accountInfo = {...result}
               console.log('res22:', result)

               this.radiogroup = result.sex
               // this.files.push(this.accountInfo.photo)
               // console.log(this.accountInfo)
            })
         },
         setNickCancel() {
            this.isPop = false
            this.setNickShow = false;
            this.nickName = ''
         },
         setNickSure() {
            this.isPop = false
            this.setNickShow = false
            // 修改业务员信息update
            if (!this.nickName) {
               const toast = this.$createToast({
                  txt: '请输入新的昵称~',
                  type: 'txt'
               }).show()
               return
            }
            this.$http.api.resetInfo({
               user_id: this.user_id,
               name: this.nickName
            }).then(result => {
               this.accountInfo.name = this.nickName
               // localStorage.removeItem('name')
               // localStorage.setItem('name',this.name)
            })
         },
         setSex() {
            this.isPop = true
            this.sexShow = true
         },
         isShowPop() {
            this.isPop = true
            this.setNickShow = true
         },
         selectGood() {
            this.checked = !this.checked
            //判断是否未定义，如果没点击过按钮是没有注册的，则需要先注册checked属性
         },
         sexNickSure() {
            /*
            let sexKind = ''
            if (this.checked) {
               sexKind = this.setValue
            } else {
               sexKind = this.setValue2
            }
            if (!sexKind) {

            }
             */


            if (this.radiogroup == '') {
               const toast = this.$createToast({
                  txt: '请选择性别~',
                  type: 'txt'
               }).show()
            } else {
               this.isPop = false
               this.sexShow = false

               this.$http.api.resetInfo({
                  user_id: this.user_id,
                  sex: this.radiogroup
               }).then(result => {
                  this.accountInfo.sex = this.radiogroup
               })


            }


         },
         sexCancel() {
            this.isPop = false
            this.sexShow = false;
            this.checked = true
         },
         loginOut() {
            localStorage.removeItem('user_id')
            localStorage.removeItem('name')
            localStorage.removeItem('phone')
            localStorage.removeItem('role_id')
            localStorage.removeItem('role')
            localStorage.removeItem('type')
            localStorage.removeItem('photo')
            localStorage.removeItem('sex')
           /*
            this.$router.push({name: 'login'})

            */
           window.location.href = this.$store.state.windowhref
         },
         filesAdded() {
            const file = this.files[0]
            file && this.$refs.upload.removeFile(file)
         },
         /**
          * 文件上传成功回调
          */
         filesSuccess(files) {
            // console.log(this.files)
            this.$http.api.resetInfo({
               user_id: this.user_id,
               photo: files.response.obj
            }).then(result => {
               this.accountInfo.photo = files.response.obj
            })
         },
         /**文件上传删除回调 */
         fileRemoved() {
            this.photo = ''
         },
         fileError() {
            const toast = this.$createToast({
               txt: '头像上传失败，请重新上传',
               type: 'txt'
            }).show()
         },
      }
   }
</script>
<style lang='less' scoped>
  .my-account {
    width: 100%;

    .my-account-list {
      width: 100%;

      .items {
        padding: 10px 10px 12px 10px;
        background: #fff;
        border-bottom: 1px solid #ececec;
        box-sizing: border-box;

        a {
          display: block;
          height: 100%;
          line-height: 22px;

          .items-left {
            width: 30%;
            font-size: 12px;
            color: #666;
            float: left;
          }

          .items-right {
            float: right;
            width: 40%;
            font-size: 12px;
            // line-height: 12px;
            text-align: right;

            img {
              width: 60px;
              height: 60px;
              float: left;
              //   margin: 0 auto;
            }

            .items-next {
              background: url('../assets/images/j-i22.png') no-repeat center center;
              width: 10px;
              height: 16px;
              margin-left: 5px;
              display: inline-block;
              vertical-align: middle;
            }

            .items-right-text {
              display: inline-block;
              color: #BCBCBC;
              font-size: 12px;
            }
          }

          .right-avator {
            width: 25%;
            line-height: 65px;
            position: relative;

            img {

            }
          }
        }

        .avator {
          .items-left {
            height: 65px;
            line-height: 65px;
          }
        }
      }

      .sex {
        margin-bottom: 5px;
      }
    }

    .login-out-account {
      width: 100%;
      position: absolute;
      bottom: 0;
      height: 44px;
      line-height: 44px;
      background: #61B0E3;

      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        text-align: center;
        color: #fff;
        font-size: 15px;
      }
    }

    .addressPop {
      display: block;
    }

    .nick-input {
      width: 100%;
      margin-bottom: 10px;
      height: 30px;
      line-height: 30px;
      // label {
      //   width:30%;
      //   float: left;
      //   height:30px;
      //   line-height:30px;
      //   margin-right:4%;
      // }
      input {
        width: 100%;
        float: right;
        border: 1px solid #ccc;
        outline: none;
        background: #fff;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
      }
    }

    .isshow {
      height: auto;
    }

    .sexName {
      width: 100%;
      height: 30px;
      line-height: 30px;
      // float: left;
      span:nth-child(1) {
        float: left;
        font-size: 14px;
      }
    }

    .sex-input-box {
      width: 100%;
    }

    .sex-input {
      width: 15px;
      height: 15px;
      float: right;
      background: url(../assets/images/ylab5.png) center center no-repeat;
      background-size: contain;
      // background: #444;
      vertical-align: middle;
      margin: 0 auto;
      margin-top: 7.5px;
      // margin-right: 5px;
    }

    .checked {
      width: 15px;
      height: 15px;
      float: right;
      background: url(../assets/images/ylab3on.png) center center no-repeat;
      background-size: contain;
      vertical-align: middle;
      margin: 0 auto;
      margin-top: 7.5px;
    }
  }

  .cube-upload {
    width: 60px;
    height: 60px;
    float: left;
    position: absolute;
    top: 0;
    left: 0;

    /deep/ .cube-upload-file, .cube-upload-btn {
      margin: 0;
      height: 60px;

      /deep/ .cube-upload-input {
        height: 60px;
      }
    }

    /deep/ .cube-upload-file {
      margin: 0;

      + .cube-upload-btn {
        margin-top: -60px;
        opacity: 0;
      }
    }

    /deep/ .cube-upload-file-state {
      background: none;

      .cube-upload-file-status.cubeic-right {
        display: none;
      }
    }

    /deep/ .cube-upload-file-def {
      width: 100%;
      height: 100%;
      background: transparent;
      background-size: 100% 100%;

      .cubeic-wrong {
        display: none;
      }
    }

    .cube-upload-btn {
      display: flex;
      align-items: center;
      justify-content: center;

      > div {
        width: 100%;
        height: 100%;
        text-align: center;
        background: transparent;
      }

      i {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        margin-bottom: 20px;
        font-size: 32px;
        line-height: 1;
        font-style: normal;
        color: #fff;
        background-color: transparent;
        border-radius: 50%;
      }
    }
  }


</style>


